import { render, staticRenderFns } from "./ClientMedia.vue?vue&type=template&id=8c433b8e"
import script from "./ClientMedia.vue?vue&type=script&lang=js"
export * from "./ClientMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports